import classes from "./Section2.module.css";

export default function Section2() {
  return (
    <div className={classes.section2Wrapper}>
      <div className={classes.section2Container}>
        <div className={classes.section2Image}>
          <img src="/img/about-img/about-us-section.jpg" alt="about-us" />
        </div>
        <div className={classes.section2Content}>
          <h2>
            About <span>TechMatter</span>
          </h2>
          <p>
            We are the leading providers of cutting-edge technologies. Storage
            devices, computer memory, motherboards, printers, scanners, power
            supplies, CPUs, Servers, and Network devices are all covered in
            detail. The TechMatter makes every effort to ensure that its
            customers are completely satisfied. We can help you improve your PC
            to meet your gaming needs or increase corporate efficiency.
          </p>
          <p>
            Every Step Is Versatile – Our hardware is aimed at both full-fledged
            networks and individuals searching for general use. We welcome you
            with open arms, whether you are a huge corporation looking to buy in
            bulk or an individual looking to upgrade your hardware.
          </p>
          <p>
            With printers, scanners, and servers from the world’s leading
            manufacturers, it’s difficult to go wrong. We deliver money for
            value in our products for our budget-conscious customers, ensuring
            that you receive your money’s worth with whatever product you
            require. Our rapid delivery ensures that you receive your products
            in the finest possible condition in the shortest possible period.
          </p>
        </div>
      </div>

      <div className={classes.section3Container}>
        <div className={classes.section2Content}>
          <h2>
            Our <span> Mission </span>
          </h2>

          <p>
            Our motto is “Your Convenience.” We make it easy to upgrade your
            existing systems or devices with our branded modules. Replacing
            devices on a regular basis means disturbing the network you worked
            so hard to set up. We provide the most up-to-date technical modules
            that are simple to set up and install, ensuring that your business
            does not suffer and remains at the top.
          </p>
          <p>
            Power supplies, cable and modules, racks and cabinets, and other
            computer needs are all available at the TechMatter. We also host
            authentic and licensed computer software such as Windows,
            sophisticated server applications, software licenses, and whatever
            else you may require. We take our claims very seriously and work
            hard to make sure we can meet your every requirement.
          </p>
        </div>
        <div className={classes.section2Image}>
          <img src="/img/about-img/about-us-section-2.jpg" alt="about-us" />
        </div>
      </div>
    </div>
  );
}
